import React from "react";
import { Outlet } from "react-router-dom";

const BillToMapping = () => {
  return <Outlet />;
};

export default BillToMapping;
